// 菜单 侧边栏
let data = []
if (window.sessionStorage.getItem('state') && window.sessionStorage.getItem('state') === 'true') {
  data = [
    { path: '/operate/supplier/home', title: '首页', icon: 'home', hideDot: true },
    { path: '/operate/supplier/goods', title: '商品管理', icon: 'cubes', hideDot: true },
    { path: '/operate/supplier/order', title: '订单管理', icon: 'table', hideDot: true },
    { path: '/operate/supplier/staff', title: '人员管理', icon: 'user', hideDot: true },
  ]
} else {
  data = [
    { path: '/operate/home', title: '首页', icon: 'home', hideDot: true },
    { path: '/operate/goods/tabs', title: '商品管理', icon: 'cubes', hideDot: true },
    { path: '/operate/order/tabs', title: '订单管理', icon: 'table', hideDot: true },
    { path: '/operate/purchase/tabs', title: '配送管理', icon: 'truck', hideDot: true },
    { path: '/operate/cloud/d2One', title: '云库存', icon: 'cloud', hideDot: true },
  ]
}
export default data
